import { jsx as _jsx } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';

const FilterLoadingComponent = ({
  height
}) => /*#__PURE__*/_jsx(UIFlex, {
  style: {
    height: height || 90
  }
});

export default FilterLoadingComponent;